/**
 * Sentry Error Tracking
 */

import * as Sentry from '@sentry/browser';

const isDev = import.meta.env.DEV;
const SENTRY_DSN = 'https://24f6f0a4609cb35ea1a29767a2e9db9f@o4510640603201536.ingest.de.sentry.io/4510640609493072';

export function initSentry(): void {
  if (isDev) {
    console.log('[Sentry] Disabled in development mode');
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: 'production',
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.1, // 10% of transactions
    beforeSend(event) {
      // Filter out non-critical errors if needed
      return event;
    },
  });
}

export function captureError(error: Error, context?: Record<string, unknown>): void {
  if (isDev) {
    console.error('[Sentry] Would capture:', error, context);
    return;
  }

  Sentry.captureException(error, {
    extra: context,
  });
}

export function setUser(userId: string, email?: string): void {
  if (isDev) {
    console.log('[Sentry] Would set user:', { userId, email });
    return;
  }

  Sentry.setUser({ id: userId, email });
}

export function clearUser(): void {
  if (isDev) {
    console.log('[Sentry] Would clear user');
    return;
  }

  Sentry.setUser(null);
}
